<template>
  <div class="main">
    <header>
      <div class="logout" id="logout" v-show="showLogin" @mouseleave="hideLogin" @mouseenter="showLoginMark">
        <li v-show="!token" style="cursor: pointer" @click="toLoginPage">登录</li>
        <li v-show="token" style="cursor: pointer" @click="logout">退出登录</li>
      </div>
      <div class="top">
        <div class="login" style="border-radius: 0">

          <img @click="toHomePage" style="border-radius: 0; cursor: pointer;" src="../../../static/image/logo.png" alt="">
        </div>

        <div class="login" @mouseleave="hideLogin" @mouseenter="showLoginMark">
          <img :src="avatarUrl + '?t=' + (new Date().getTime())" alt="">
          {{displayName}}
        </div>
      </div>
    </header>
    <div class="content">
      <el-row>
        <el-col v-for="(o, index) in newsList" style="width: 100%; margin-bottom: 10px;">
          <el-card style="padding-bottom: 10px; height: 240px;cursor:pointer;"   @click.native="toDetails(o.id)" >
            <div>
              <div style="float: left;width: 10%;margin-top: 1px;"><img style="width:200px;height: 200px;" :src=o.imageUrl>
              </div>
              <div style="margin-left: 260px; font-size: 23px;font-weight: 600;overflow:hidden;">
                {{ o.title }}
              </div>
              <p style="margin-top: 2%"><time class="time" style="margin-left: 12%">{{o.createTime}}</time></p>

            </div>
           <!-- <div style="margin-left: 85%;margin-top:125px;width: 100%;">
              <div class="bottom clearfix">
                <time class="time">{{o.createTime}}</time>
              </div>
            </div>-->
          </el-card>
        </el-col>
      </el-row>
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>
    </div>
    <Footer style="position: fixed; bottom: 0;"></Footer>
  </div>
</template>

<script>
  import Footer from '../common/footer';

  export default {
    inject: ['reload'],
    name: "productPage",
    components: {
      Footer
    },
    data() {
      return {
        newsList:'',
        name: "",
        showLogin: false,
        products: [],
        productObj: {},
        actionName: "",
        avatarUrl: "",
        displayName: localStorage.getItem('name'),
        token: localStorage.getItem('token'),
      }
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        if (from.name == 'loginPage') {
          vm.$router.go(0);
        }
      })
    },
    created() {
      this.getData();
    },
    mounted() {
      let logout = document.getElementById('logout');
      logout.style.right = (document.body.clientWidth - 1220) / 2 + 'px';
      this.avatarUrl = localStorage.getItem('avatarUrl') || require('../../../static/image/header.jpg');
    },
    methods: {
      getData(){
        this.$store.dispatch('findNewsList').then((res) => {
          if (res.data.code == 200) {
            this.newsList = res.data.data.list;
            console.log(res.data.data.list);
          } else {

          }
        })
      },
      toProductPage() {
        this.$router.push({
          path: "/server"
        })
      },
      toLoginPage() {
        this.$router.push({
          path: '/login'
        })
      },

      logout() {
        this.avatarUrl = require('../../../static/image/header.jpg');
        this.token = !this.token;
        this.displayName = "";
        localStorage.clear();
        this.$router.push({
          name: "productPage"
        })
      },

      showLoginMark() {
        this.showLogin = true;
      },
      toDetails(id){
        this.$router.push({
          path: "/serverProductDetails/" + id
        })
      },
      hideLogin() {
        this.showLogin = false;
      },

      initClear() {
        this.pageNum = 1;
        this.products = [];
      },

      toProductDetailsPage(productId) {
        this.$router.push({
          path: "/serverProductDetails/" + productId
        })
      },

      toHomePage() {
        this.$router.push({
          path: '/'
        })
      },

    }
  }
</script>

<style scoped lang="scss">
  .active {
    color: #000;
    font-size: 17px;
    font-weight: 500;
  }

  .shadow:hover {

    -webkit-box-shadow: #ccc 0px 10px 10px;
    -moz-box-shadow: #ccc 0px 10px 10px;
    box-shadow: #ccc 0px 10px 10px;
    transition-property: all;
    transition-duration: 1s;


  }

  .header_content {
    height: 100px;
    float: right;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;

    li {
      padding: 0 40px;
      font-size: 18px;
      color: #555;
      cursor: pointer;
    }
  }

  .main {
    width: 100%;

    header {
      width: 100%;
      background: #fff;
      height: 100px;
      position: relative;

      .logout {
        width: 100px;
        height: 50px;
        position: absolute;
        top: 70px;
        border: 1px solid #f2f2f2;
        border-radius: 6px;
        background: #fff;

        li {
          text-align: center;
          line-height: 50px;
        }
      }

      .top {
        height: 100px;
        width: 1220px;
        margin: 0 auto;
        overflow: hidden;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .login {
          width: auto;
          height: 50px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 16px;

          img {
            display: block;
            width: 50px;
            height: auto;
            border-radius: 50%;
            margin-right: 10px;
          }
        }

        .search {
          width: 700px;
          height: 50px;
          background: #fff;
          border: 1px solid #B0BECB;
          display: flex;

          input {
            width: 600px;
            outline: none;
            border: none;
            height: 48px;
            font-size: 18px;
          }

          label {
            width: 50px;
            height: 50px;
            display: block;

            img {
              display: block;
              width: 30px;
              height: auto;
              margin: 10px 10px;
            }
          }
        }

        .allCategory {
          margin-top: 20px;
          float: right;
          margin-right: 560px;
        }
      }
    }

    .ulType {
      display: flex;
      overflow-x: scroll;
      webkit-overflow-scrolling: touch;
      justify-content: center;
      font-size: 15px;
      color: #999;
      width: 1220px;
      margin: 0 auto;

      li {
        list-style: none;
        padding: 10px 10px;
        height: 100%;
        text-align: center;
      }
    }

    .ulType::-webkit-scrollbar {
      display: none
    }

    .swipe {
      width: 976px;
      margin: 0 auto;
      //margin-top: 5/$sc+rem;

      .swiper-zoom-container {
        width: 100%;

        img {
          width: 976px;
          height: auto;
          display: block;
        }
      }
    }

    .content {
      width: 1220px;
      margin: 50px auto 100px;

      ul {
        display: flex;
        flex-wrap: wrap;

        li {
          width: 25%;
          padding-bottom: 15px;

          .img {
            width: 100%;
            height: 270px;
            display: flex;
            align-items: center;
            justify-content: center;

            img {
              height: 80%;
              width: auto;
              display: block;
            }
          }

          .main_content {
            width: 90%;
            margin-left: 5%;

            .title {
              font-weight: 500;
              overflow: hidden;
              height: 25px;
              display: block;
              align-items: center;
              vertical-align: middle;
              text-align: center;
              font-size: 20px;
            }

            .subtitle {
              -webkit-line-clamp: 2;
              text-overflow: ellipsis;
              display: -webkit-box;
              overflow: hidden;
              -webkit-box-orient: vertical;
              text-align: center;
              color: #626262;
              //padding-bottom: 10px;
              margin-top: 10px;
              height: 40px;

            }

            .liBottom {
              width: 100%;
              display: flex;
              align-items: center;
              justify-content: space-around;
              flex-direction: row;
              width: 94%;
              margin-left: 3%;
              margin-top: 20px;

              i {
                display: block;
                font-style: normal;
                width: 50%;
                font-size: 20px;
                text-align: center;
              }

              em {
                display: block;
                font-style: normal;
                width: 50%;
                text-align: center;
                color: #ccc;
                font-size: 14px;
              }
            }
          }
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/product/serverProductPage.vue